import { useEffect, useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router";

import { Box, useTheme } from "@mui/material";
import LoginIcon from '@mui/icons-material/Login';


import { AuthProvider, AuthResponse, SignInPage } from "@toolpad/core";
import { Button, CardBody, CardHeader, Checkbox, Input, addToast } from "@heroui/react";


import { useAuth } from "../hooks/useAuth"; // Use your useAuth hook
import Card from "../components/Card";
import { Screen, Column } from "../components/Layout";
import TextHero from "../components/typography/TextHero";

export default function SignIn() {
    const { isAuthenticated, login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [remember, setRemember] = useState<string>("on")
    const [signInError, setSignInError] = useState<string | null>(null)


    useEffect(() => {

        if (signInError != null) {

            addToast({
                title: "Error",
                description: signInError,
                color: "danger",
                variant: "bordered"
            })
        }

    }, [signInError])

    if (isAuthenticated) {
        const callbackUrl = new URLSearchParams(location.search).get('callbackUrl') || '/';
        return <Navigate to={callbackUrl} replace />;
    }

    const signIn = async (_: any, formData: FormData): Promise<AuthResponse> => {
        let success: string | undefined = "Login successful.";
        let error: string | undefined;
        let type: string | undefined;

        try {
            const email = formData.get('email') as string;
            const password = formData.get('password') as string;
            const remember = formData.get('remember') === 'on';

            const result = await login(email, password, remember);

            if (result) {

                const callbackUrl = new URLSearchParams(location.search).get('callbackUrl') || '/';
                navigate(callbackUrl, { replace: true });

            } else {

                throw new Error("Invalid email or password");
            }

        } catch (e) {
            success = undefined;
            error = (e as Error).message;
            type = (e as Error).name;

            // console.error(error)

            setSignInError(error);

        } finally {
            const response: AuthResponse = { success, error, type };
            return response;
        }
    }

    return (
        // <Box>
        //     <SignInPage
        //         signIn={signIn}
        //         localeText={{
        //             // signInTitle: "Sign In To Automation Tools"
        //         }}
        //         providers={[{ id: 'credentials', name: 'Credentials' }]}
        //         slotProps={{ emailField: { autoFocus: false }, form: { noValidate: true } }}
        //     />
        // </Box>
        <Screen>
            <Column
                expand
                fullWidth
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Box maxWidth={{ sx: "90%", md: "500px" }} minWidth={"360px"} width={"25%"}>
                    <Card>
                        <CardHeader style={{ textAlign: "center" }}>
                        </CardHeader>
                        <CardBody>
                            <Column alignItems={"center"} >

                                <Box width={"300px"} margin={2}>
                                    {/* <img src="/images/panda_tools.png" alt="Panda Tools" /> */}
                                    <img src="/images/sauron.png" />
                                </Box>

                                <TextHero>Login</TextHero>
                                <Column fullWidth gap={2.5}>


                                    <Input
                                        isClearable
                                        onClear={() => { setEmail("") }}
                                        // size="sm"
                                        labelPlacement="outside"
                                        name="email"
                                        label="E-mail"
                                        variant="bordered"
                                        onValueChange={setEmail}
                                    />
                                    <Input
                                        // isClearable
                                        // onClear={() => { setEmail("") }}
                                        // size="sm"
                                        type="password"
                                        name="password"
                                        labelPlacement="outside"
                                        label="Password"
                                        variant="bordered"
                                        onValueChange={setPassword}
                                    />

                                    <Checkbox radius="sm" defaultSelected defaultChecked onValueChange={(isSelected) => { setRemember(isSelected ? "on" : "off") }}>Remember me</Checkbox>
                                    <Button variant="flat" size="lg" fullWidth onPress={() => {
                                        setSignInError(null)

                                        var formData: FormData = new FormData();
                                        formData.set("email", email);
                                        formData.set("password", password);
                                        formData.set("remember", remember)

                                        signIn(undefined, formData)

                                    }} style={{ marginTop: "16px" }} endContent={<LoginIcon />}>Login</Button>
                                </Column>

                            </Column>

                        </CardBody>
                    </Card>
                </Box>

            </Column>
        </Screen>
    );
}
